export class WorkgroupMember{

    constructor(
        public userId:string,
        public initials:string,
        public firstname:string,
        public middlename:string,
        public lastname:string,
        public email:string,
        public roleId:string,
        public roleTitle:string,
    ){}
} 